import React from "react";
import s from "../style.module.css";

export default function LargeScreen({
  contentPaulSab,
  contentN7,
  contentAirfrance,
  contentOrange,
  contentAirbus,
  contentDevhop,
  contentKoncept,
  icon,
  section,
}) {
  return (
    <>
      <div className="row">
        {section("Expériences professionnelles", "worker")}
      </div>
      <div className={`${s.contImgCode} row`}>
        <img
          className={s.imgCode}
          src="/assets/codeLines.webp"
          alt="code lines"
        />
        {icon("devhop.webp", true, false)}
        <div
          className={`${s.text} col-5 d-flex align-items-start justify-content-start`}
        >
          {contentDevhop()}
        </div>
      </div>
      <div className={`row`}>
        <div
          className={`${s.text} col-5 d-flex align-items-start justify-content-end`}
        >
          {contentAirfrance()}
        </div>
        {icon("airfrance.webp", false, false)}
        <div className="offset-5"></div>
      </div>
      <div className="row">
        {icon("airbus.webp", true, false)}
        <div
          className={`${s.text} col-5 d-flex align-items-start justify-content-start`}
        >
          {contentAirbus()}
        </div>
      </div>
      <div className="row">
        <div
          className={`${s.text} col-5 d-flex align-items-start justify-content-end`}
        >
          {contentKoncept()}
        </div>
        {icon("koncept.jpeg", false, false)}
        <div className="offset-5"></div>
      </div>
      <div className="row">
        {icon("orange.webp", true, false)}
        <div
          className={`${s.text} col-5 d-flex align-items-start justify-content-start`}
        >
          {contentOrange()}
        </div>
      </div>
      <div className="row">{section("Formations", "student")}</div>
      <div className={`row`}>
        <div
          className={`${s.text} col-5 d-flex align-items-start justify-content-start`}
        >
          {contentN7()}
        </div>
        {icon("enseeiht.webp", false, false)}
      </div>
      <div className="row">
        {icon("paulsab.webp", true, true)}
        <div
          className={`${s.text} col-5 d-flex align-items-start justify-content-start`}
        >
          {contentPaulSab()}
        </div>
      </div>
      {section("Rejoignez l'aventure !", "end")}
    </>
  );
}
